import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PreviousJobTitle } from '../entities/previous-job-title';

import { Observable } from 'rxjs/Observable';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class PreviousJobTitleService extends BaseCrudService<PreviousJobTitle>{
    
    public uri = '/api/previousJobTitle/';

    constructor(injector:Injector){
        super(injector);
       //console.log('Instance PreviousJobTitleService');
    }

    buildSentence(entity?: PreviousJobTitle, event?: LazyLoadEvent): HttpParams {
      this.httpParams = new HttpParams();
      if (entity) {
        let query = '';
        query = query.concat(
          entity.code ?
            `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
            : QueryOperator.Empty
        );
        query = query.concat(
          entity.name ?
            `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
            : QueryOperator.Empty
        );
        if (entity.executingUnit && entity.executingUnit.id) {
          query = query.concat(
            `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
          );
        }
        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      }
  
      if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
      }
      return this.httpParams;
    }
    
    getSequenceCode(): Observable<string> {
      const url = this.rutaServidor + this.uri + 'maxCode/';
      return this.httpClient.get<any>(url)
          .pipe(
              map(response => {
                  // debugger;
                  const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 5);
                  const sequence = (parseInt(code, 10)) + 1;
                  return FormatUtils.padLeftZero(sequence, 5);
              }),
              tap(response => {
                 //console.log(response);
              })
          );
  }
}


// WEBPACK FOOTER //
// ./src/app/core/services/previous-job-title.service.ts